import type { InputHTMLAttributes, ReactNode, Ref } from 'react';
import type { SwitchSize } from './Switch.css';
import {
  root,
  rootDisabled,
  controlWrapper,
  nativeInput,
  track,
  knob,
  labelText,
} from './Switch.css';

export type { SwitchSize };

export interface SwitchProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'size'> {
  /** Ref to the underlying input */
  ref?: Ref<HTMLInputElement>;
  /** Visual size */
  switchSize?: SwitchSize;
  /** Visible label rendered next to the control. Provide this or `aria-label` for accessibility. */
  label?: ReactNode;
  /** Custom class name applied to the root label */
  className?: string;
}

export function Switch({
  switchSize = 'md',
  disabled = false,
  label,
  className,
  ref,
  ...props
}: SwitchProps) {
  return (
    <label
      className={`${root}${disabled ? ` ${rootDisabled}` : ''}${className ? ` ${className}` : ''}`}
    >
      <span className={controlWrapper}>
        <input
          ref={ref}
          type="checkbox"
          role="switch"
          disabled={disabled}
          className={nativeInput}
          {...props}
        />
        <span className={track[switchSize]} aria-hidden="true">
          <span className={knob[switchSize]} />
        </span>
      </span>
      {label != null && <span className={labelText[switchSize]}>{label}</span>}
    </label>
  );
}
